import { Capacitor } from "@capacitor/core";

export interface CapacitorPlatformSource {
  getPlatform(): string;
  isNativePlatform(): boolean;
}

export interface RuntimePlatform {
  readonly isNative: boolean;
  readonly name: string;
}

export const detectRuntimePlatform = (
  source: CapacitorPlatformSource = Capacitor,
): RuntimePlatform => ({
  isNative: source.isNativePlatform(),
  name: source.getPlatform(),
});
